import { CSSProperties, Fragment } from 'react'
import { IndexRange } from 'utils/string/fuzzySearchList'
import { Nullish } from 'utils/utiltyTypes/utilityTypes'

interface HighlightedTextProps {
  text: string
  highlightedRanges: Nullish<IndexRange[]>
  highlightStyle?: CSSProperties
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  highlightedRanges,
  highlightStyle = defaultHighlightStyle,
}) => {
  if (!highlightedRanges) return <>{text}</>

  const parts = []
  let lastIndex = 0

  highlightedRanges.forEach(([start, end]) => {
    const normalText = text.slice(lastIndex, start)
    const highlightedText = text.slice(start, end + 1)

    parts.push(<Fragment key={`normal-${start}-${end}`}>{normalText}</Fragment>)
    parts.push(
      <span key={`highlighted-${start}-${end}`} style={highlightStyle}>
        {highlightedText}
      </span>
    )
    lastIndex = end + 1
  })

  parts.push(<Fragment key="normal-last">{text.slice(lastIndex)}</Fragment>)

  return <>{parts}</>
}

const defaultHighlightStyle = {
  backgroundColor: '#ffe4b5',
}
